import * as React from "react";
import { UserContext } from "./UserContext";

export function useUser() {
  return React.useContext(UserContext);
}
